import React, { ChangeEvent } from "react";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import { EVideoListTab } from "../helpers";
import useStyles from "./styles";

interface IProps {
  activeTab: EVideoListTab;
  onChangeActiveTab: (value: EVideoListTab) => void;
}

const TrackOpticsTabs = (props: IProps) => {
  const { activeTab, onChangeActiveTab } = props;
  const classes = useStyles();

  const handleChangeActiveTab = (
    event: ChangeEvent<HTMLButtonElement>,
    value: EVideoListTab
  ) => {
    onChangeActiveTab(value);
  };

  return (
    <div className={classes.contentHeader}>
      <Tabs
        value={activeTab}
        className={classes.tabs}
        onChange={handleChangeActiveTab}
        TabIndicatorProps={{
          className: classes.activeTab
        }}
      >
        <Tab
          className={classes.tab}
          label={EVideoListTab.WORKOUTS}
          value={EVideoListTab.WORKOUTS}
        />
        <Tab
          className={classes.tab}
          label={EVideoListTab.REVIEWED}
          value={EVideoListTab.REVIEWED}
        />
      </Tabs>
    </div>
  );
};

export default React.memo(TrackOpticsTabs);
